import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GetQuoteComponent } from './get-quote/get-quote.component';
import { QuotationPremiumComponent } from './quotation-premium/quotation-premium.component';
import { ProposalFormComponent } from './proposal-form/proposal-form.component';
import { MyQuotationComponent } from './my-quotation/my-quotation.component';
import { CompareProductComponent } from './compare-product/compare-product.component';
import { ProposalFormV1Component } from './proposal-form-v1/proposal-form-v1.component';

const routes: Routes = [
  { path: '', redirectTo: 'get-quote', pathMatch: 'full' },
  { path: 'get-quote', component: GetQuoteComponent },
  { path: 'get-quote/:quotationId', component: GetQuoteComponent },
  { path: 'quotation-premium/:quotationId', component: QuotationPremiumComponent },
  { path: 'proposal-form/:quotationId/:quotesId', component: ProposalFormV1Component},
  { path: 'proposal-form-edit/:quotationId/:quotesId', component: ProposalFormV1Component},
  { path: 'proposal-form-v1/:quotationId/:quotesId', component: ProposalFormComponent },
   { path: 'my-quotation', component: MyQuotationComponent },
  { path: 'compare-product/:quotationId', component: CompareProductComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuotationRoutingModule { }
